import { TOOL_DECISION_REFUSAL } from '@kentik/ui-shared/kaizen/constants';

export const REFUSAL_TEXT = {
  [TOOL_DECISION_REFUSAL.NOT_CONNECTED]: (serverName) => `${serverName} isn't connected yet.`,
  [TOOL_DECISION_REFUSAL.UNAVAILABLE]: (serverName) => `${serverName} is temporarily unavailable. Try again.`
};
